export default "__VITE_PUBLIC_ASSET__284e43e6__"